import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../store/useAuthStore";
import toast from "react-hot-toast";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const CustomerForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const customerForgotPassword = useAuthStore((state) => state.customerForgotPassword);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email address.");
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    setMessage("");
    try {
      const success = await customerForgotPassword(email);
      if (success) {
        setMessage(
          "Please check your email for the password"
        );
        setEmail("");
      }
    } catch (error) {
      console.error("Forgot password request failed:", error);
      setMessage("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 relative"
      style={{
        backgroundImage: "url('/assets/CustomerBg.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-black opacity-50 z-0"></div>
      <div className="w-full max-w-md p-8 bg-white/90 rounded-lg shadow-2xl border border-gray-300 relative z-10 backdrop-blur-sm">
        <h2 className="text-2xl font-semibold text-center text-gray-800 mb-6">
          Forgot Password
        </h2>
        <p className="text-center text-gray-600 text-sm mb-6">
          Enter your customer account email and we'll send a link to reset your password.
        </p>

        {message && (
          <div className="mb-4 p-3 bg-green-100 text-green-700 text-sm rounded-md text-center">
            {message}
          </div>
        )}

        {!message && (
          <form onSubmit={handleSubmit}>
            <div className="mb-5">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
                style={{ backgroundColor: "#f3f4f6", borderRadius: "12px" }}
                placeholder="Enter your registered email"
                required
                disabled={loading}
              />
            </div>

            <div className="flex flex-col items-center">
              <button
                type="submit"
                disabled={loading}
                className={`w-full sm:w-auto px-6 py-2 mt-2 text-white transition-all duration-300 flex items-center justify-center rounded-xl font-medium ${loading ? "opacity-70 cursor-not-allowed bg-blue-400" : "bg-blue-600 hover:bg-blue-700"
                  }`}
              >
                {loading ? (
                  <>
                    <AiOutlineLoading3Quarters className="animate-spin mr-2" />
                    Sending...
                  </>
                ) : (
                  "Verify Email"
                )}
              </button>

              <button
                type="button"
                onClick={() => navigate("/login?type=customer")}
                className="mt-4 text-sm text-blue-600 hover:underline"
                disabled={loading}
              >
                Back to Login
              </button>
            </div>
          </form>
        )}

        {message && (
          <div className="flex justify-center mt-4">
            <button
              type="button"
              onClick={() => navigate("/login?type=customer")}
              className="text-sm text-blue-600 hover:underline"
            >
              Back to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerForgotPasswordPage;